var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircularClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FEE4E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 40.5413C21.0817 40.5413 15.4584 34.918 15.4584 27.9997C15.4584 21.0813 21.0817 15.458 28 15.458C34.9184 15.458 40.5417 21.0813 40.5417 27.9997C40.5417 34.918 34.9184 40.5413 28 40.5413ZM28 17.208C22.05 17.208 17.2084 22.0497 17.2084 27.9997C17.2084 33.9497 22.05 38.7913 28 38.7913C33.95 38.7913 38.7917 33.9497 38.7917 27.9997C38.7917 22.0497 33.95 17.208 28 17.208Z",
    fill: "#F73C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30.0413C27.5217 30.0413 27.125 29.6447 27.125 29.1663V23.333C27.125 22.8547 27.5217 22.458 28 22.458C28.4783 22.458 28.875 22.8547 28.875 23.333V29.1663C28.875 29.6447 28.4783 30.0413 28 30.0413Z",
    fill: "#F73C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 33.8334C27.8484 33.8334 27.6967 33.7984 27.5567 33.74C27.4167 33.6817 27.2884 33.6 27.1717 33.495C27.0667 33.3784 26.985 33.2617 26.9267 33.11C26.8684 32.97 26.8334 32.8184 26.8334 32.6667C26.8334 32.515 26.8684 32.3634 26.9267 32.2234C26.985 32.0834 27.0667 31.955 27.1717 31.8384C27.2884 31.7334 27.4167 31.6517 27.5567 31.5934C27.8367 31.4767 28.1634 31.4767 28.4434 31.5934C28.5834 31.6517 28.7117 31.7334 28.8284 31.8384C28.9334 31.955 29.015 32.0834 29.0734 32.2234C29.1317 32.3634 29.1667 32.515 29.1667 32.6667C29.1667 32.8184 29.1317 32.97 29.0734 33.11C29.015 33.2617 28.9334 33.3784 28.8284 33.495C28.7117 33.6 28.5834 33.6817 28.4434 33.74C28.3034 33.7984 28.1517 33.8334 28 33.8334Z",
    fill: "#F73C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularClose);
export default __webpack_public_path__ + "static/media/circular-close.7fde3c7debf6d3a39aa0b7280c57a2c2.svg";
export { ForwardRef as ReactComponent };